import React from 'react';

import { Typography, List, Row, Col } from 'antd';

const { Paragraph, Text } = Typography;

const ExistedProductApl = (props) => {
  const { productList } = props;

  return (
    <div>
      <Paragraph style={{ textAlign: 'center', marginBottom: 8 }}>
        List product(s)
      </Paragraph>
      <div className='scroller' style={{ height: 250, margin: '0px 20px' }}>
        <List
          bordered
          itemLayout='horizontal'
          dataSource={productList}
          renderItem={(product, index) => (
            <List.Item style={{ textAlign: 'left' }}>
              <List.Item.Meta
                title={
                  <Text style={{ fontWeight: 'bold' }} level={5}>
                    {product.productName}
                  </Text>
                }
                description={
                  <Row gutter={8}>
                    <Col span={12}>
                      <Text strong>GTIN: </Text>
                      <Text>{product.gtin}</Text>
                    </Col>
                    <Col span={12}>
                      <Text strong>UPC12: </Text>
                      <Text>{product.upc12}</Text>
                    </Col>
                  </Row>
                }
              />
            </List.Item>
          )}
        />
      </div>
      <Paragraph style={{ textAlign: 'center', margin: '12px 0px 0px' }}>
        that exists within the chosen APL
      </Paragraph>
    </div>
  );
};

export default ExistedProductApl;
